import { Box, Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from "styled-components";

const Hero = () => {
  const navigate = useNavigate()

  const handleViewCourses = () => {
    navigate('/getstarted')
  }
  return (
    <HeroWrapper className = "bg-black">
      <div className='container h-100 flex'>
        <div className='hero-content'>
          <h1>Unlock your Potential</h1>
          <h1>With the best IELTS </h1>
          <h1>Trainers</h1>
          <p>Shop our courses today!</p>
          <Box mt={2}>
          <Button variant='contained' color='error' size='large' onClick={handleViewCourses}> Get Started</Button>
          </Box>
        </div>

        
      </div>
      
    </HeroWrapper>
  )
}

const HeroWrapper = styled.div`
  background: url('/images/hero_img.png') center/cover no-repeat;
  height: 500px;

  .container{
    .hero-content{
      background-color: var(--clr-white);
      max-width: 400px;
      width: 100%;
      margin-left: 0;
      padding: 20px;

      h1{
        font-size: 32px;
        margin-bottom: 5px;
        white-space: nowrap;
      }
      p{
        font-size: 15px;
      }
    }
  }
`;

export default Hero